<template>
  <div class="member-info">
    <admin-title title="全域紧急联系人" />

    <card class="member-list">
      <tp-table
        :table-data="qyMemberContactList"
        :columns="columns"
        :is-page="false"
      />
    </card>
  </div>
</template>

<script>
const columns = [
  {
    label: "平台名称",
    prop: "appName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{ row["appName"] }</p>
    }
  },
  {
    label: "姓名",
    prop: "contactName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{ row["contactName"] }</p>
    }
  },
  {
    label: "联系电话",
    prop: "contactMobile",
    minWidth: "120",
    customRender(h, row) {
      return <p>{ row["contactMobile"] }</p>
    }
  },
  {
    label: "关系",
    prop: "relation",
    minWidth: "100",
    customRender(h, row) {
      return <p>{ row["relation"] }</p>
    }
  },
  {
    label: "备注",
    prop: "remark",
    minWidth: "240",
    customRender(h, row) {
      return <p>{ row["remark"] }</p>
    }
  },
];

export default {
  name: "QyMemberContactList",

  props: {
    qyMemberContactList: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      columns,
    };
  },
};
</script>

<style lang="scss" scoped>
.member-info /deep/ {
  width: 100%;
  border: 1px solid #c5c5c5;
  border-radius: 15px;
  padding: 15px 20px;

  .member-list {
    .blacklist {
      color: #ffffff;
      background-color: #000000;
      font-weight: bold;
    }
    .whitelist {
      color: #000000;
      background-color: #ffffff;
      font-weight: bold;
    }
  }
}
</style>
